var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowClockwise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5156 3.41406C17.8608 3.41406 18.1406 3.69388 18.1406 4.03906V7.78906C18.1406 8.13424 17.8608 8.41406 17.5156 8.41406H13.7656C13.4204 8.41406 13.1406 8.13424 13.1406 7.78906C13.1406 7.44388 13.4204 7.16406 13.7656 7.16406H16.8906V4.03906C16.8906 3.69388 17.1704 3.41406 17.5156 3.41406Z",
    fill: "#1F8598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2173 3.87047C10.0048 3.6289 8.74784 3.75237 7.6055 4.22527C6.46317 4.69817 5.48675 5.49924 4.79976 6.52716C4.11278 7.55508 3.74609 8.76365 3.74609 10C3.74609 11.2364 4.11278 12.4449 4.79976 13.4728C5.48675 14.5008 6.46317 15.3018 7.6055 15.7747C8.74784 16.2476 10.0048 16.3711 11.2173 16.1295C12.4298 15.888 13.5434 15.2922 14.4173 14.4176C14.6613 14.1734 15.057 14.1733 15.3012 14.4173C15.5454 14.6612 15.5455 15.057 15.3016 15.3011C14.2529 16.3506 12.9165 17.0656 11.4615 17.3554C10.0065 17.6453 8.49818 17.4972 7.12738 16.9297C5.75658 16.3622 4.58488 15.4009 3.7605 14.1674C2.93612 12.9339 2.49609 11.4836 2.49609 10C2.49609 8.51638 2.93612 7.06609 3.7605 5.83259C4.58488 4.59909 5.75658 3.6378 7.12738 3.07032C8.49818 2.50284 10.0065 2.35468 11.4615 2.64456C12.9164 2.93442 14.2526 3.64921 15.3012 4.69853C15.3013 4.69864 15.3011 4.69841 15.3012 4.69853L17.957 7.34647C18.2014 7.59019 18.202 7.98592 17.9583 8.23036C17.7146 8.47479 17.3188 8.47538 17.0744 8.23166L14.4173 5.58239C13.5434 4.7078 12.4298 4.11204 11.2173 3.87047Z",
    fill: "#1F8598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowClockwise);
export default __webpack_public_path__ + "static/media/ArrowClockwise.b12ef5cc538a42b76f7ac94b8ec3ec08.svg";
export { ForwardRef as ReactComponent };